import { Controller } from '@hotwired/stimulus';
import markerSVG from '../../images/icons/map-marker.svg';
import markerActiveSVG from '../../images/icons/map-marker-active.svg';
import { getMeta } from '../helpers';

export default class extends Controller {

    async connect() {

        let locations = this.element.dataset.locations;
        locations = locations ? JSON.parse(locations) : {};
        if (locations.length < 1) {
            return;
        }

        import('leaflet').then((L) => {
            Promise.all([
                import('protomaps-leaflet'),
                import('leaflet-gesture-handling'),
                import('leaflet/dist/leaflet.css')
            ]).then(([protomapsL, GestureHandling]) => {
                this.element.removeAttribute('data-locations');

                const map = L.map(this.element, {
                    center: [locations[0]['lat'], locations[0]['lng']],
                    zoom: 8,
                    zoomSnap: false,
                    scrollWheelZoom: false,
                    gestureHandling: true,
                });

                protomapsL.leafletLayer({
                    attribution: '',
                    maxZoom: 16,
                    url: 'https://api.protomaps.com/tiles/v4/{z}/{x}/{y}.mvt?key=ef5c5085b99a07d8',
                    flavor: 'light',
                    lang: 'en'
                }).addTo(map);

                const markerIcon = L.icon({
                    iconUrl: markerSVG,
                    iconSize: [41, 64],
                    iconAnchor: [20, 64],
                    popupAnchor: [0, 0],
                });

                const activeMarkerIcon = L.icon({
                    iconUrl: markerActiveSVG,
                    iconSize: [41, 64],
                    iconAnchor: [20, 64],
                    popupAnchor: [0, 0],
                });

                const markers = [];
                locations.forEach((data) => {
                    const marker = L.marker([data['lat'], data['lng']], {
                        icon: markerIcon,
                        slug: data['slug'],
                    });
                    marker.addTo(map);
                    markers.push(marker);
                });

                if (locations.length > 1) {
                    const bounds = new L.featureGroup(markers).getBounds();
                    map.fitBounds(bounds, { padding: [50, 100] });

                    window.addEventListener('resize', () => {
                        setTimeout(() => {
                            const bounds = new L.featureGroup(markers).getBounds();
                            map.fitBounds(bounds, { padding: [50, 100] });
                        }, 10);
                    });
                }

                const activeMapLocation = new URLSearchParams(window.location.search).get('map-location');
                if (activeMapLocation) {
                    const headerOffset = 200;
                    const offsetPosition = this.element.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) - headerOffset;
                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth',
                    });
                }

                markers.forEach((marker) => {
                    if (activeMapLocation && marker.options.slug === activeMapLocation) {
                        marker.setIcon(activeMarkerIcon);
                    } else {
                        marker.setIcon(markerIcon);
                    }
                    marker.on('click', () => {
                        markers.forEach((m) => m.setIcon(markerIcon));
                        marker.setIcon(activeMarkerIcon);

                        const url = new URL(window.location.href);
                        url.searchParams.set('map-location', marker.options.slug);
                        history.pushState({}, '', url);
                    })
                });

                const resourcePath = getMeta('theme-url');
                if ('serviceWorker' in navigator) {
                    navigator.serviceWorker.register(resourcePath + 'map-worker.js').catch(console.error);
                }
            });
        })
    }
}
